import React, {useState, useEffect} from 'react';
import log from 'loglevel';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Drawer } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { NotificationManager } from 'react-notifications';
import checkUtils from '../../../util/checkUtils'
import dashServerApis from '../../../util/dashServerApis'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import _ from "lodash";
import ReactGA from "react-ga";


export default (props) => {
	const f = global.f
	let [check] = global.get("check")
	let debug = true
	const [drawer, setDrawer] = React.useState(false);
	const [hasNonDashPayments] = global.get("hasNonDashPayments");
	const [tipsEnabled] = global.get("tipsEnabled");
	const [tipPercentagesEnabled] = global.get("tipPercentagesEnabled");
	const [customTipEnabled] = global.get("customTipEnabled");
	const [noTipButtonEnabled] = global.get("noTipButtonEnabled");
	const [customTip, setCustomTip] = React.useState(0);
	const [showCustomTip, setShowCustomTip] = useState(false);
	const [customTipFormatted, setCustomTipFormatted] = React.useState("");
	const onMyBillPage = props.page === "MyBillPage"
	const onReceiptPage = props.page === "ReceiptPage"
	const [ loyaltyProgram ] = global.get('loyaltyProgram');
	const [ loyaltyAccount ] = global.get('loyaltyAccount');
	const [ hasPersonIdentifiers ] = global.get('hasPersonIdentifiers');

	const TIP_SELECTED_GA_ACTION = 'Tip Selected';

	let checkTotals = check.paidInFull ? check.paidItemsTotals : check.unpaidItemsTotals
	if (onMyBillPage) {
		checkTotals = check.myTotals
	}

	useEffect(() => {
		document.addEventListener('focusout', e => {
			// console.log(e.target.id);
			// THIS IS TO CLOSE THE MODAL WHEN THE ACCESSORY DONE BUTTON IS PRESSED
			if (e.target.id === 'customTipField') {
				setTimeout(() => {
					setShowCustomTip(false);
				}, 100);
			}
		})
	},[])

	const clickedTipButton = (tipAmount) => {
		log.info("TIP : " + tipAmount);
		if (onMyBillPage) { // if the user is on the select items receipt page
			let checkWithTip = checkUtils.updateTotals(check, tipAmount)
			log.info(checkWithTip)
			// global.pageStack.push({ pageName: props.page, fn: moveBackToYourBill })
			global.pageStack.push({ pageName: props.page, fn: null })
			global.set({ allowBack: true, check: checkWithTip, finalizedItemChoices: true })
			if (loyaltyProgram && !loyaltyAccount) {
				global.set({ header: false, footer: false, activePage: "LoyaltyWrapper" })	
			} else {
				global.set({ activePage: "PaymentPage" })
			}
		} else if (!check.hasLockedItemsByOthers || hasNonDashPayments) { // if others have already selected items, redirect to select items tab
			dashServerApis.lockAllItems(check, debug).then((json) => {
				if (json.success) {
					check.items.forEach((item) => {
						item.locked = true
						item.lockedByMe = true
						item.lockedBy = localStorage.firstName + " " + localStorage.lastName
						item.lockedByInitials = localStorage.initials
					})
					let checkWithTip = checkUtils.updateTotals(check, tipAmount)
					global.pageStack.push({ pageName: props.page, fn: null })
					if (loyaltyProgram && !loyaltyAccount) {
						global.set({ allowBack: true, check: checkWithTip, lockedAll: true, header: false, footer: false, activePage: "LoyaltyWrapper" })
					} else {
						global.set({ allowBack: true, check: checkWithTip, lockedAll: true, activePage: "PaymentPage" })
					}
				} else {
					let checkWithTip = checkUtils.updateTotals(check, 0)
					global.set({ check: checkWithTip })
					if (props.setTabIndex && !hasNonDashPayments) {
						props.setTabIndex(props.selectItemsTab);
					}
				}
			}).catch((err) => {
				NotificationManager.warning("", "An error occurred on the server, please try again", 3000);
			})
		} else {
			let title = (check.othersWhoHaveLocks)  ? check.othersWhoHaveLocks : ""
			let sepWord = " has"
			if (check.othersWhoHaveLocks.toLowerCase().indexOf(" and ") > -1) {
				sepWord = " have"
				title = "Others"
			}
			if (!hasNonDashPayments) {
				NotificationManager.warning('', title  + sepWord + " already selected items to pay for. Please select your items.", 3000);
				props.setTabIndex(props.selectItemsTab);
			} else {
				NotificationManager.warning('', title  + sepWord + " already selected items to pay for.", 3000);
			}
		}
		
		toggleShowTip(false);
		
	}

	const toggleDrawer = (side, open) => event => {
		if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
			return;
		}

		setDrawer(!drawer);
	};

	const handleSetCustomTip = (customTipIn) => {
		// remove non numeric values from string & set state
		if (customTipIn) {
			const newCustomTip = customTipIn.replace(/\D/g, '');
			if (newCustomTip !== customTip) {
				setCustomTip(parseFloat(newCustomTip))
				setCustomTipFormatted(toCurrency(newCustomTip));
			}
		}
	}

	const toCurrency = (number) => {
		const formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2
		})
		return formatter.format(number / 100);
	}


	const c = makeStyles((theme) => ({
		root: {
			height: '100%'
		},
		gridTipFooter: {
			padding: '0px 20px 5px 20px',
			height: '100%',
			position: 'relative',
			alignContent: 'flex-end'
		},
		tipButton: {
			width: '100%',
			boxShadow: 'none',
			backgroundColor: '#eeeeee',
			height: '100%',
			paddingTop: 10,
		},
		tipButtonText: {
			lineHeight: 1,
		},
		tipButtonTextAmount: {
			color: 'var(--text)',
			lineHeight: 1,

		},
		modalContainer: {
			width: '100%',
			height: '100%',
			background: 'var(--mask)',
			position: 'fixed',
			top: 0,
			left: 0,
			elevation: 100,
		},
		modalWrapper: {
			width: '100%',
			height: 'auto',
			position: 'absolute',
			left: 0,
			bottom: 0,
			right: 0,
			backgroundColor: 'rgba(96%, 96%, 96%, 0.925)',
		},
	}))();

	const toggleShowTip = (value) => {
		if (value != showCustomTip) {
			setShowCustomTip(value);
		}
	}

	const tipButtonPercentages = check.restaurant.config.mobile.tipButtonPercentages 
	const tipPercentageLeft = (typeof tipButtonPercentages.left ===  "number") ? tipButtonPercentages.left * .01 : .25;
	const tipPercentageCenter = (typeof tipButtonPercentages.center === "number") ? tipButtonPercentages.center * .01 : .20;
	const tipPercentageRight = (typeof tipButtonPercentages.right === "number") ? tipButtonPercentages.right * .01 : .15
	const tipPercentageLeftStr = tipPercentageLeft > 0 ? (tipPercentageLeft * 100).toFixed(0) + '%' : "CASH"
	const tipPercentageCenterStr = tipPercentageCenter > 0 ? (tipPercentageCenter * 100).toFixed(0) + '%' : "CASH"
	const tipPercentageRightStr = tipPercentageRight > 0 ? (tipPercentageRight * 100).toFixed(0) + '%' : "CASH"
	const tipBasisAmount = check.restaurant.config.mobile.tipsIncludeTax ? (checkTotals.items + checkTotals.taxes) : checkTotals.items
	const autoTip = f(check, "totals.autoTip", 0) > 0

	return (
		<Grid container spacing={1} className={c.gridTipFooter}>
			{tipsEnabled && <>
				<Grid item xs={12} align="center" style={{paddingBottom: 8}}>
					<Typography variant="button" style={{color: 'var(--text)', lineHeight: 1.5}}>{autoTip ? "Tip already applied" : (tipPercentagesEnabled? "Please select a tip to begin" : "Please enter a tip to begin")}</Typography>
				</Grid>
				{tipPercentagesEnabled && !autoTip &&
					<Grid container align="center" spacing={1} style={{paddingBottom: 8}}>
						<Grid item xs={4} align="center">
							<Button variant="contained" component="span" className={c.tipButton} onClick={() => {
									clickedTipButton(Math.round(tipBasisAmount * tipPercentageLeft, 2));
									ReactGA.event({
										category: TIP_SELECTED_GA_ACTION,
										action: 'Left',
										label: tipPercentageLeftStr,
									});
									}}>
								<div>
									<Typography color="primary" variant="h6" className={c.tipButtonText}>{tipPercentageLeftStr}</Typography>
									<Typography variant="overline" className={c.tipButtonTextAmount}>${checkUtils.formatMoney(tipBasisAmount * tipPercentageLeft)}</Typography>
								</div>
							</Button>
						</Grid>
						<Grid item xs={4} align="center">
							<Button variant="contained" component="span" className={c.tipButton} onClick={() => {
								clickedTipButton(Math.round(tipBasisAmount * tipPercentageCenter, 2))
								ReactGA.event({
									category: TIP_SELECTED_GA_ACTION,
									action: 'Center',
									label: tipPercentageCenterStr
								});
							}}>
								<div>
									<Typography color="primary" variant="h6" className={c.tipButtonText}>{tipPercentageCenterStr}</Typography>
									<Typography variant="overline" className={c.tipButtonTextAmount}>${checkUtils.formatMoney(tipBasisAmount * tipPercentageCenter)}</Typography>
								</div>
							</Button>
						</Grid>
						<Grid item xs={4} align="center">
							<Button variant="contained" component="span" className={c.tipButton} onClick={() => { 
								clickedTipButton(Math.round(tipBasisAmount * tipPercentageRight, 2)); 
								ReactGA.event({
									category: TIP_SELECTED_GA_ACTION,
									action: 'Right',
									label: tipPercentageRightStr
								});
								} }>
								<div>
									<Typography color="primary" variant="h6" className={c.tipButtonText}>{tipPercentageRightStr}</Typography>
									<Typography variant="overline" className={c.tipButtonTextAmount}>${checkUtils.formatMoney(tipBasisAmount * tipPercentageRight)}</Typography>
								</div>
							</Button>
						</Grid>
					</Grid>
				}
				{(customTipEnabled || noTipButtonEnabled) && 
					<Grid container align="center" spacing={1} style={{height: '42%', paddingBottom: 8}}>
						{customTipEnabled &&
							<Grid item xs={(noTipButtonEnabled && !autoTip) ? 8 : 12} align="center">
								<Button variant="contained" component="span" className={c.tipButton} onClick={() => { 
										toggleShowTip(true); 
									}}
								>
									<Typography color="primary" variant="subtitle1" className={c.tipButtonText}>{autoTip ? 'Additional Tip' : 'Custom Tip'}</Typography>
								</Button>
							</Grid>
						}
						{noTipButtonEnabled && !autoTip && 
							<Grid item xs={customTipEnabled ? 4 : 12} align="center">
								<Button variant="contained" component="span" className={c.tipButton} onClick={() => { 
										clickedTipButton(0)
									}}
								>
									<Typography color="primary">Cash Tip</Typography>
								</Button>
							</Grid>
						}
					</Grid>
				}

			</>}
			{(!tipsEnabled || (tipsEnabled && autoTip)) && <>
				<Grid container align="center" spacing={1} style={{height: '42%', paddingBottom: 8}}>
					<Grid item xs={12} align="center">
						<Button variant="contained" className={c.tipButton} component="span" style={{fontSize:'1.4em'}} onClick={()=> {clickedTipButton(0)}}>
							<Typography color="primary" variant="subtitle1" className={c.tipButtonText}>Pay</Typography>
						</Button>
					</Grid>
				</Grid>
			</>}
			{showCustomTip && customTipEnabled &&
					<div className={c.modalContainer}>
						<div className={c.modalWrapper}>
							<Grid container spacing={1}>
								<Grid item xs={8}>
									<TextField
										id="customTipField"
										autoFocus
										placeholder="$0.00"
										value={customTipFormatted}
										onChange={(event) => handleSetCustomTip(event.target.value)}
										type="tel"
										pattern="[0-9]*"
										margin="normal"
										style={{width:'75%', height: 'auto', padding: '8px 0px'}}
										label={"Tip Amount (" + ((customTip / checkTotals.total) * 100).toFixed(0) + "%)"}
										inputProps={{ maxLength: 7 }}
										onKeyUp={(event) => { if (event.key === 13) clickedTipButton(customTip)}}
									/>
								</Grid>
								<Grid item xs={3} style={{margin: 'auto'}}>
									{customTipFormatted.length > 0 &&
										<Button color="primary" variant="contained" component="span" onClick={() => {
												clickedTipButton(customTip)
												ReactGA.event({
													category: TIP_SELECTED_GA_ACTION,
													action: 'Custom',
													label: ((customTip / checkTotals.total) * 100).toFixed(0) + "%"
												});
					
											}}>
											<Typography variant="subtitle1" >Done</Typography>
										</Button>
									}
								</Grid>
							</Grid>
						</div>
					</div>
				}
 			{/* <Drawer style={{height: 300}} anchor="bottom" open={drawer} onClose={toggleDrawer('bottom', false)}>
				<Grid container spacing={1}>
					<Grid item xs={8} style={{marginLeft:10}} align="center">
						<TextField
							autoFocus
							placeholder="$0.00"
							value={customTipFormatted}
							onChange={(event) => handleSetCustomTip(event.target.value)}
							type="tel"
							pattern="[0-9]*"
							margin="normal"
							style={{width:'75%'}}
							label={"Tip Amount (" + ((customTip / checkTotals.total) * 100).toFixed(0) + "%)"}
							inputProps={{ maxLength: 7 }}
							onKeyUp={(event) => { if (event.key === 'Enter') clickedTipButton(customTip); }}
							/>
					</Grid>
					<Grid item xs={3} style={{marginTop:15}} align="center">
						{ customTip !== 0 &&
						<Button color="primary" variant="contained" component="span" onClick={() => clickedTipButton(customTip)}>
							<Typography variant="subtitle1" >Done</Typography>
						</Button>
						}
					</Grid>
				</Grid>
			</Drawer> */}
		</Grid>
	)

}
